import { useCallback, useMemo, useState } from "react";

import { LinearProgress, Typography } from "@mui/material";

import { CreditCardItemType, useGetCreditCards } from "@/api/creditCard";
import { CREDIT_CARD_PAGE_CHANGE_KEYWORDS } from "@/constants/eventName";
import { dispatchEvent } from "@/hooks/useEventEmitter";

import CreditCardItem from "./components/CreditCardItem";
import FilterBar from "./components/FilterBar";
import SearchBar from "./components/Search";
import useColorMode from "@/hooks/useColorMode";
import useThemeData from "@/hooks/useThemeData";
const CreditCard = () => {
  const { isLoading, data } = useGetCreditCards();

  const [filterData, setFilterData] = useState<CreditCardItemType[]>([]);

  const searchData = useMemo(() => data?.cards ?? [], [data]);

  const [keyword, setKeyword] = useState("");

  const filterChange = useCallback((value: CreditCardItemType[]) => {
    setFilterData(value);
  }, []);

  const { mode, colorMode, isDarkMode } = useColorMode();
  const theme = useThemeData();
  return (
    <div className="max-w-6xl mx-[10px] md:mx-auto">
      <div className="text-center my-[20px]">
        <Typography variant="h4" color="textPrimary">
          Credit Card
        </Typography>
      </div>
      <div className="mb-4 p-3">
      <Typography variant="body1" color="textPrimary" className={theme.isDarkMode?`mb-10 p-4 rounded-md text-sm bg-gray-800`:`mb-10 p-4 rounded-md text-sm bg-gray-100`}>
        <strong>Advertiser Disclaimer</strong>
        <p className="mt-2">
          We may receive compensation when you click on product links. This may affect product placement but doesn't influence our evaluations. Our team conducts independent research to provide you with the best options while maintaining editorial integrity and transparency.
        </p>
        <p className="mt-2">
          💰 We earn a commission when you apply for a credit card through our links, which keeps AwardTool humming along with free, comprehensive features. 🔗 If you need to apply for a card, it would be greatly appreciated if you could use our reference link. ☕ Thanks for fueling our caffeine addiction and keeping the lights on—we appreciate your support more than you know! 🙏
        </p>
      </Typography>
      </div>

      <SearchBar
        value={keyword}
        onChange={(v) => {
          setKeyword(v);
          dispatchEvent(CREDIT_CARD_PAGE_CHANGE_KEYWORDS, v);
        }}
      />

      <div className="my-[20px]">
        <FilterBar
          dataSourceList={searchData}
          onChange={filterChange}
          banks={data?.banks}
          category={data?.categories}
        />
      </div>

      {isLoading ? (
        <div className="mt-[25px] mx-[10px]">
          <LinearProgress />
        </div>
      ) : null}

      <div className="space-y-[10px]">
        {filterData.map((cardInfo) => {
          return (
            <CreditCardItem
              isDetail={false}
              key={cardInfo.id}
              data={cardInfo}
              categories={data.categories}
            />
          );
        })}
      </div>
    </div>
  );
};
export default CreditCard;
